import {ParsedUrlQuery} from 'querystring';
import {convertQueryInputToSingleElement} from '../../common/shared/utils/convertQueryInputToSingleElement';

export function getDayOfWeekParamFromQuery({
  uidInfoList,
  query,
}: {
  uidInfoList: string[];
  query?: ParsedUrlQuery;
}) {
  if (!uidInfoList) {
    return null;
  }
  const [category_uid, subcategory_uid] = uidInfoList;
  const categoryUid = convertQueryInputToSingleElement(category_uid);
  const subcategoryUid = convertQueryInputToSingleElement(subcategory_uid);
  const bmType = convertQueryInputToSingleElement(query?.bm);
  const dayTabUid = convertQueryInputToSingleElement(query?.tab_uid);

  return {
    categoryUid: Number(categoryUid),
    subcategoryUid,
    bmType,
    dayTabUid,
  };
}
